import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel} from 'shared/components';
import VisibilityPreferenceToggle from './VisibilityPreferenceToggle';
import EditVisibilitySettingModal from './EditVisibilitySettingModal';

const CalendarVisibilityPanel = observer(({uiState}) => {
  const {birthdayCelebration, startDateCelebration, anniversaryCelebration, peopleOffToday} = uiState;

  return (
    <Panel>
      <Panel.Header title={t('company_settings.visibility_settings.Company Calendar Visibility Preferences')}/>
      <div className='jumbo mb2'>
        <FormattedMessage
          id='company_settings.visibility_settings.CALENDAR_VISIBILITY_NOTICE'
          values={{
            link: <a href='/calendar' target='_blank'>
                    <FormattedMessage id='company_settings.visibility_settings.company calendar'/>
                  </a>
          }}
        />
      </div>
      <VisibilityPreferenceToggle uiState={uiState} setting={birthdayCelebration}/>
      <Panel.Separator/>
      <VisibilityPreferenceToggle uiState={uiState} setting={startDateCelebration}/>
      <Panel.Separator/>
      <VisibilityPreferenceToggle uiState={uiState} setting={anniversaryCelebration}/>
      <Panel.Separator/>
      <VisibilityPreferenceToggle uiState={uiState} setting={peopleOffToday}/>
      <EditVisibilitySettingModal uiState={uiState}/>
    </Panel>
  );
});

export default CalendarVisibilityPanel;
